"use strict";

/*
 ## External Dependencies ##
  - jQuery ($)
  - $.mask
 */

// Tries to define new due date when
// - User selects a date on datepicker
// - User clicks outside the box

var _ = require("underscore");
var moment = require("moment");

var visualDateFormat = "DD/MM/YYYY";
var sysDateFormat = "YYYY-MM-DD";
var visualTimeFormat = "HH:mm";
var sysTimeFormat = "HH:mm:ss";
var maxTime = "23:59:59";
var DatePicker = require("app/shared/components/DatePicker/date-picker");

var DatetimePicker = React.createClass({
  mixins: [React.addons.LinkedStateMixin],
  propTypes: {
    dueDate: React.PropTypes.string,
    afterClose: React.PropTypes.func,
    stateChangeListener: React.PropTypes.func,
    closeParentElem: React.PropTypes.func,
    closeAfterSetValidDatetime: React.PropTypes.bool,
    closeParentElem: React.PropTypes.func,
    closeOnEnterPress: React.PropTypes.bool,
    closeOnClickDate: React.PropTypes.bool,
    afterClose: React.PropTypes.func
  },
  getInitialState: function() {
    return this.getUpdatedState(this.props);
  },
  getDefaultProps: function() {
    return {
      dueDate: new Date(),
      closeAfterSetValidDatetime: true,
      closeOnEnterPress: false,
      afterClose: null,
      stateChangeListener: null
    };
  },
  componentDidMount: function() {
    $(this.refs.date).mask("00/00/0000");
    $(this.refs.time).mask("00:00");
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState(this.getUpdatedState(nextProps));
  },
  getUpdatedState: function(props) {
    var dueDate = moment(props.dueDate);
    var date = dueDate.format(visualDateFormat);
    var time = (dueDate.format(sysTimeFormat)==maxTime)?null:dueDate.format(visualTimeFormat);
    return {
      visualDate: date,
      visualTime: time,
      validDate: dueDate.format(sysDateFormat),
      validTime: dueDate.format(sysTimeFormat)
    };
  },
  onParentClose: function() {
    if (this.props.afterClose) {
      this.props.afterClose(this.state.validDate, this.state.validTime);
    }
  },
  onSelectDate: function(newSysDate, newSysTime) {
    var state = {};
    var visualDate = null;
    var visualTime = null;

    if (newSysDate) {
      visualDate = moment(newSysDate).format(visualDateFormat);
      state.visualDate = visualDate;
    } else {
      visualDate = this.state.visualDate;
    }

    if (newSysTime && typeof newSysTime=="string") {
      if (newSysTime==maxTime) {
        visualTime = "";
      } else {
        visualTime = moment(newSysTime, sysTimeFormat).format(visualTimeFormat);
      }
      state.visualTime = visualTime;
    } else {
      visualTime = this.state.visualTime;
    }

    var sysDateObj = this.validateDate(visualDate);
    var sysTimeObj = this.validateTime(visualTime);
    var sysDate = sysDateObj.sysDate;
    var sysTime = sysTimeObj.sysTime;

    if (sysDate!=this.state.validDate||sysTime!=this.state.validTime) {
      if (sysDateObj.isValid) {
        state.validDate = sysDate;
      }
      if (sysTimeObj.isValid) {
        state.validTime = sysTime;
      }
    }

    this.setState(state);
    if (this.props.stateChangeListener) {
      this.props.stateChangeListener(state);
    }

    if (this.props.closeAfterSetValidDatetime) {
      if (this.props.closeParentElem) {
        this.props.closeParentElem();
      }
    }
  },
  validateDate: function(inputVisualDate) {
    var visualDate = moment(inputVisualDate, visualDateFormat, true);
    var isValid = (visualDate.isValid());
    var sysDate = null;

    if (inputVisualDate!="" && isValid) {
      sysDate = visualDate.format(sysDateFormat);
    }

    return {sysDate: sysDate, isValid: isValid};
  },
  validateTime: function(inputVisualTime) {
    var visualTime = moment(inputVisualTime, visualTimeFormat, true);
    var isValid = (visualTime.isValid()||inputVisualTime=="");
    var sysTime = maxTime;

    if (inputVisualTime!="" && isValid) {
      sysTime = visualTime.format(sysTimeFormat);
    }

    return {sysTime: sysTime, isValid: isValid};
  },
  onChangeInputDate: function(e) {
    var calendar = this.refs.calendar;
    var parsedDate = moment(e.target.value, visualDateFormat, true);
    this.setState({
      visualDate: e.target.value
    });
    if (parsedDate.isValid()) {
      var sysDate = parsedDate.format(sysDateFormat);
      $(calendar).datepicker("setDate", sysDate);
      this.onSelectDate(sysDate);
    }
  },
  onChangeInputTime: function(e) {
    // Needed when user types fast and the mask is not applied in time
    var value = e.target.value;
    var isTimeNotFormatted = (value.length==4&&value.indexOf(":")==-1);
    if (isTimeNotFormatted) {
      value = value.replace(/(\d{2})(\d{2})/i, "$1:$2");
    }

    this.setState({
      visualTime: value
    });
    var sysTimeObj = this.validateTime(value);
    if (sysTimeObj.isValid) {
      this.onSelectDate(null, sysTimeObj.sysTime);
    }
  },
  onKeyDown: function(e) {
    if (e.keyCode==13) {
      this.onSelectDate();
      if (this.props.closeOnEnterPress) {
        this.close();
      }
    }
  },
  close: function() {
    if (this.props.closeParentElem) {
      this.props.closeParentElem();
    }
    if (this.props.afterClose) {
       this.props.afterClose(this.state.validDate, this.state.validTime);
    }
  },
  render: function() {
    var datePickerProps = {
      selectedDate: this.state.validDate,
      onSelectDate: this.onSelectDate,
      shouldCloseOnSelect: this.props.closeOnClickDate,
      onClose: this.close
    };

    return (
      <div className="datetimePicker-datetimeWrapper form-inline">
        <div className="datetimePicker-datetime form-group">
          <input className="datetimePicker-date form-control input-sm" onChange={this.onChangeInputDate} onKeyDown={this.onKeyDown} placeholder="dd/mm/aaaa" value={this.state.visualDate} ref="date" type="text" />
          <span className="mr-8">&agrave;s</span>
          <input className="datetimePicker-time form-control input-sm" onChange={this.onChangeInputTime} onKeyDown={this.onKeyDown} placeholder="hh:mm" value={this.state.visualTime} ref="time" type="text" />
        </div>
        <DatePicker {...datePickerProps} />
      </div>
    );
  }
});

module.exports = DatetimePicker;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/datetime-picker.jsx